import React from 'react';
import CtUsers from '../pages-content/Users-content/Users.content';

const Users:React.FC = () => {
  return (
    <>
      <CtUsers />
    </>
  )
}

export default Users;